module.exports = __webpack_public_path__ + "img/flowPath-item5-on.df1b3cd4.png";